import { render } from "./DisplaySetting.vue?vue&type=template&id=8fcef73a"
import script from "./DisplaySetting.vue?vue&type=script&lang=js"
export * from "./DisplaySetting.vue?vue&type=script&lang=js"

import "./DisplaySetting.vue?vue&type=style&index=0&id=8fcef73a&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__